export default __webpack_public_path__ + "static/media/836.9d50e39b.png";